export default __webpack_public_path__ + "static/desktop-popup-0faa99c6884caf33460997eac43dc630.jpg";